module.exports = __webpack_public_path__ + "static/media/price.81b50e07.svg";